let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eJ6pr")).then(() => parcelRequire('500cH'));